import React, { useCallback } from 'react';
import VariablesSelector from 'containers/components/VariablesSelector';
import { Icon } from '@Sage/hoi-poi-ui';

const FieldInsertButton = ({
    onChange,
    useCampaignReplaceVariables = false,
    formatInsertedVariable,
}) => {
    const handleApply = useCallback(
        (variable) => {
            onChange?.({ value: variable });
        },
        [onChange],
    );

    return (
        <VariablesSelector
            onApply={handleApply}
            useCampaignReplaceVariables={useCampaignReplaceVariables}
            formatInsertedVariable={formatInsertedVariable}
        >
            <button type="button" className="textarea-field-insert__btn">
                <Icon name="variables" />
            </button>
        </VariablesSelector>
    );
};

FieldInsertButton.displayName = 'FieldInsertButton';
export default FieldInsertButton;
